import { dataAiBubble } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAiBubble = /*#__PURE__*/createIcon(dataAiBubble)
export default IconAiBubble
